import ResourceService from "./resource.service";

class AdminConfigurationService extends ResourceService {
  static get resource() {
    return "admin-configuration";
  }
}

export default AdminConfigurationService;